import 'css-chunksrc/client/pages/projectPage/documentsPage/documentsPage/document/styles.scss';export default {
  "document": "_document_dcida_1",
  "icon": "_icon_dcida_35",
  "name": "_name_dcida_40",
  "size": "_size_dcida_46",
  "avatar": "_avatar_dcida_52",
  "creationDate": "_creationDate_dcida_57",
  "contextualMenu": "_contextualMenu_dcida_62",
  "removeIcon": "_removeIcon_dcida_74",
  "loader": "_loader_dcida_78"
};